import {Injectable} from '@angular/core';
/**
 * Created by K.Lapihin on 03.05.2018.
 */

export class DynamicStylesHelper {
  constructor(name: string, styleLinks: any[]) {
    this.name = name;
    this.styleLinks = styleLinks;
  }

  name: string;
  styleLinks: any[];

  addStyles() {

    if (document.location.href.includes('lk.uk-akadem.ru')) {
      document.getElementById('iconLink').setAttribute('href', 'img/icon/academ-favicon-32x32.png');
    }

    for (const styleLink of this.styleLinks) {
      const timestamp = new Date().getTime();
      const styleNode = document.createElement('link');
      styleNode.rel = 'stylesheet';
      styleNode.href = styleLink + '?v=' + timestamp;
      styleNode.classList.add(this.name);
      document.head.insertAdjacentElement('beforeend', styleNode);
    }
  }

  clearStyles() {
    const styleList = document.head.getElementsByClassName(this.name);
    while (styleList.length > 0) {
      document.head.removeChild(styleList.item(0));
    }
  }
}





// WEBPACK FOOTER //
// D:/dev/smartcityspace_git/web/frontend/src/main/frontend/src/app/_service/dinamic-styles.service.ts